import { t } from '@/locale/index.js'
import { applyColumnLabels, applyOptionLabels, applySearchLabels } from '@/utils/listPageI18n.js'

const TASK_SUBMIT_COLUMNS = {
  id: 'taskSubmit.recordId',
  title: 'taskSubmit.taskName',
  real_name: 'taskSubmit.submitterName',
  username: 'taskSubmit.submitterUsername',
  mobile: 'taskSubmit.submitterMobile',
  created_at: 'taskSubmit.createdAt',
  updated_at: 'taskSubmit.updatedAt',
  status: 'field.status',
  operation: 'table.operation',
}

const TASK_STATUS_MAP = {
  0: 'taskSubmit.statusNotSubmitted',
  1: 'taskSubmit.statusPending',
  2: 'taskSubmit.statusApproved',
  3: 'taskSubmit.statusRejected',
}

/** 特殊任务提交记录列表 */
export function applyTaskSubmitLabels({ searchData, columns, statusOptions }) {
  applySearchLabels(searchData, {
    task_id: { labelKey: 'taskSubmit.taskName' },
    keywords: { labelKey: 'field.keywords' },
    status: { labelKey: 'field.status' },
    real_name: { labelKey: 'taskSpecial.publisher' },
  })
  applyColumnLabels(columns, TASK_SUBMIT_COLUMNS)
  applyOptionLabels(statusOptions, TASK_STATUS_MAP)
}

const IMPROVE_SUBMIT_COLUMNS = {
  ...TASK_SUBMIT_COLUMNS,
  score: 'detail.score',
  material_url: 'improveSubmit.material',
  note: 'improveSubmit.reportContent',
}

const IMPROVE_STATUS_MAP = {
  0: 'taskSubmit.statusNotSubmitted',
  1: 'improveSubmit.statusInProgress',
  2: 'taskSubmit.statusPending',
  3: 'improveSubmit.statusPass',
  4: 'improveSubmit.statusFail',
}

/** 技能提升提交记录列表 */
export function applyImproveSubmitLabels({ searchData, columns, statusOptions }) {
  applySearchLabels(searchData, {
    task_id: { labelKey: 'taskSubmit.taskName' },
    keywords: { labelKey: 'field.keywords' },
    status: { labelKey: 'field.status' },
  })
  applyColumnLabels(columns, IMPROVE_SUBMIT_COLUMNS)
  applyOptionLabels(statusOptions, IMPROVE_STATUS_MAP)
}

export { t }
